var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs",class:( _obj = {}, _obj[_vm.classPrefix + '-tabs'] = _vm.classPrefix, _obj )},_vm._l((_vm.dataSource),function(item){return _c('li',{key:item.value,staticClass:"tabs-item",class:_vm.liClass(item),on:{"click":function($event){return _vm.select(item)}}},[_vm._v(_vm._s(item.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }